export default "__VITE_ASSET__BRAEQVgi__"